export const PAYMENT_TYPE = {
  DIRECT: "PayDirect",
  WALLET: "PayFromWallet",
};
